<template>
  <div class="ibox deployment-agency">
    <div class="ibox-title">
      <h2>{{ $t('hospitality.deployment.agency.title') }}</h2>
    </div>
    <div :class="'ibox-content p-md' + (listLoading ? ' sk-loading' : '')">

      <div v-if="listLoading" class="sk-spinner sk-spinner-double-bounce">
          <div class="sk-double-bounce1"></div>
          <div class="sk-double-bounce2"></div>
      </div>

      <p>{{ $t('hospitality.deployment.agency.note') }}</p>

      <form role="form" @submit="onFormSubmit" name="publish-agency">
        <button class="btn btn-primary ladda-button publish-agency" data-style="zoom-in" type="submit">{{$t('hospitality.deployment.agency.button')}}</button>
      </form>

    </div>
  </div>
</template>

<script lang="ts">
import { Ref, defineComponent, PropType, computed, onMounted, onBeforeUnmount, ref, watch, reactive } from '@fwk-node-modules/vue'
import { getApp, useRouter, useStore } from '@fwk-client/utils/vue-3-migration';
import * as api from '@fwk-client/utils/api';
import * as Ladda from 'ladda';

import { useAgencyAdmin } from '../../../composables/useAgencyAdmin';

export default defineComponent({
    props: {
        
    },
    components: {
    },
    setup(props, context) {
      const app = getApp();
      const $router = useRouter();
      const $store = useStore();
      const { selectedAgency, callAgencyAdmin } = useAgencyAdmin(props, context);


      const listLoading:Ref<boolean> = ref(false);

      var laddaSubmit:Ladda.LaddaButton|null = null;

      onMounted(() => {
        var submitButton:HTMLButtonElement|null = document.querySelector( 'form[name=publish-agency] button.publish-agency' );
        laddaSubmit = Ladda.create(submitButton!);
      })

      const onFormSubmit = (evt:Event) => {
        // We prevent submit of the page
        evt.preventDefault();

        laddaSubmit!.start();

        var path = '/agency/'+selectedAgency.value.agency._id+'/deployment/publish-agency';
        
        callAgencyAdmin(path).then((response:any) => {
          if(response.published && response.agency) {  
            // We emit event
            context.emit('agency-published', response.agency);
          }

          laddaSubmit!.stop();
        });
        
      }

        return { 
          listLoading,
          onFormSubmit
        }
    }
})
</script>